export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/online_tutoring.8f0ebc3.svg";